import Vue from "vue";
import { format, parseISO } from "date-fns";

const moneyFormatter = new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" });

Vue.filter("formatBrDate", (date: string) => date ? format(parseISO(date), "dd/MM/yyyy") : "");
Vue.filter("formatBrTime", (date: string) => date ? format(parseISO(date), "HH:mm") : "");
Vue.filter("formatBrDateTime", (date: string) => date ? format(parseISO(date), "dd/MM/yyyy HH:mm") : "");
Vue.filter("formatBrMoney", (amount: string) => amount ? moneyFormatter.format(parseFloat(amount)) : "");

